import moment from 'moment';
export function standardDate(date) {
    const format = 'MMMM DD, YYYY';
    return moment(date).format(format);
}
/**
 * Short Date Formatter
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.6.0}
 *
 * @return {string}
 */
export function shortDate(date) {
    const format = 'MMM DD, YYYY';
    return moment(date).format(format);
}
/**
 * Helper function for formatting date to Standard Date and Time
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.13}
 *
 * @param {string, Date,  Moment} date argument
 *
 * @return {string} formatted date and time
 */
export function standardDateAndTime(date) {
    const format = 'MMMM DD, YYYY hh:mm A';
    return moment(date).format(format);
}
/**
 * Short Month and Day Formatter
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.50.2}
 *
 * @return {string}
 */
export function shortMonthDay(date) {
    const format = 'MMM DD';
    return moment(date).format(format);
}
